export default function throttle( fn, wait ) {
	let timeout = null;
	return function ( ...args ) {
		if ( ! timeout ) {
			timeout = setTimeout( () => {
				fn.apply( this, args );
				timeout = null;
			}, wait );
		}
	};
}
